<div class="m-subheader">
  <div class="mr-auto">
    <h3 class="m-subheader__title">
      {{ 'sales.statistics.product-category' | transloco }}
    </h3>
    <span></span>
    <hx-date-range-select [onlyPastDates]="true" class="date-align" [(ngModel)]="params.date" (selectChange)="applyFilters()"></hx-date-range-select>
  </div>
</div>

<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30">
            <table class="m-datatable__table" *ngIf="sales.length && !isloading.sales">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.category' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.amount' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.cost-price' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.total' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.profit' | transloco }}</span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <tr *ngFor="let even = even; let i = index; let item of sales"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">

                <td class="m-datatable__cell">
                  <a *ngIf="item.categoryTitle" [title]="item.categoryTitle | uiLabel" [routerLink]="['../product-sales/product-categories']" [queryParams]="{dateFrom: params.date?.from, dateTo: params.date?.to, categoryId: item.categoryId, categoryTitle: item.categoryTitle | uiLabel }">
                    {{ item.categoryTitle | uiLabel }}
                  </a>
                </td>

                <td class="m-datatable__cell">
                  {{ item.amountTotal }}
                </td>

                <td class="m-datatable__cell">
                  {{ item.costPriceTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell">
                  {{ item.valueTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell">
                  {{ (item.valueTotal - item.costPriceTotal) | fixed:2 | moneyFormat | uiCurrency: item.currency }}
                </td>

              </tr>
              </tbody>
              <tfoot class="m-datatable__foot">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell no-background">{{ 'revenue-report.table.head.total' | transloco }}</th>
                <th class="m-datatable__cell no-background">{{ totalAmount }}</th>
                <th class="m-datatable__cell no-background">{{ totalCostPrice | fixed:2 | moneyFormat }}</th>
                <th class="m-datatable__cell no-background">{{ total | fixed:2 | moneyFormat }}</th>
                <th class="m-datatable__cell no-background">{{ totalProfit | fixed:2 | moneyFormat }}</th>
              </tr>
              </tfoot>
            </table>

            <hx-loader [length]="sales.length" [isLoading]="isloading.sales"></hx-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
